import script from "./StructuredContent.vue?vue&type=script&setup=true&lang=js"
export * from "./StructuredContent.vue?vue&type=script&setup=true&lang=js"

import "./StructuredContent.vue?vue&type=style&index=0&id=8b4bf042&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b4bf042"]])

export default __exports__